/**
 * Obtiene la fecha y hora local en formato ISO (YYYY-MM-DDTHH:mm:ss.sss)
 * Ajustando el offset de la zona horaria del navegador.
 */
export const getLocalISOString = () => {
    const now = new Date();
    const offset = now.getTimezoneOffset() * 60000;
    const localDate = new Date(now.getTime() - offset);
    return localDate.toISOString();
};

/**
 * Obtiene solo la fecha local en formato YYYY-MM-DD
 */
export const getLocalDateString = () => {
    return getLocalISOString().slice(0, 10);
};

/**
 * FORMATEO SEGURO (SOLUCIÓN DE RAÍZ):
 * Convierte una fecha string (YYYY-MM-DD) del backend en un objeto Date
 * forzando el mediodía (T12:00:00) para evitar que el desfase de zona horaria 
 * (ej. UTC-5 en Bogotá) cambie el día a la fecha anterior.
 */
export const formatDateSafe = (dateStr) => {
    if (!dateStr) return null;
    // Si ya es un objeto Date, lo devolvemos
    if (dateStr instanceof Date) return dateStr;

    // Si es un string YYYY-MM-DD, le añadimos el mediodía
    if (typeof dateStr === 'string' && dateStr.length === 10) {
        return new Date(dateStr + 'T12:00:00');
    }

    // Fallback para otros formatos
    return new Date(dateStr);
};

/**
 * EXTRAER DÍA SEGURO:
 * Extrae el número del día directamente del string sin pasar por el objeto Date.
 * Esto es 100% inmune a errores de zona horaria.
 */
export const extractDayFromDate = (dateStr) => {
    if (!dateStr || typeof dateStr !== 'string') return '';
    const parts = dateStr.split('-');
    return parts.length === 3 ? parts[2] : dateStr;
};

/**
 * FORMATEAR FECHA COLOMBIA:
 * Muestra la fecha en formato legible (DD/MM/YYYY) sin saltos de día.
 */
export const formatDisplayDate = (dateStr) => {
    const date = formatDateSafe(dateStr);
    if (!date) return '';
    return date.toLocaleDateString('es-CO');
};
